import { authenticatedFetch } from "./apiClient";

export const fetchProfile = async () => {
  const response = await authenticatedFetch("/profiles/get");
  const data = await response.json().catch(() => ({}));
  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(data.error || data.message || "Failed to fetch profile");
  }
  return data;
};

export const upsertProfile = async (profile) => {
  const response = await authenticatedFetch("/profiles/upsert", {
    method: "POST",
    body: JSON.stringify({ profile }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || "Failed to save profile");
  }
  return data;
};
